import { esMembresiaVigente } from "./membresias-commons.js"
import { getSuscripcionVencimientoMesBase, getSuscripcionVigenteBase, tieneSuscripcionVencidaBase, validarSuscripcionBase, validarSuscripcionGratuitaBase, validarSuscripcionPagoBase } from "./suscripciones-commons.js"

export const susInventarioAccionFerretera = {
    SUSCRIPCION_12_MESES:
      "CAT_TRUPER_2023_&_12_MESES_ACTUALIZACIONES",
    SUSCRIPCION_6_MESES:
      "CAT_TRUPER_2023_&_6_MESES_ACTUALIZACIONES",
    SUSCRIPCION_3_MESES:
      "CAT_TRUPER_2023_&_3_MESES_ACTUALIZACIONES",
    SUSCRIPCION_1_MES: "CAT_TRUPER_2023_1_MES",
  }

export const suscripcionesDisponiblesAccionFerretera = {
    [susInventarioAccionFerretera.SUSCRIPCION_12_MESES]: {
      codigo: susInventarioAccionFerretera.SUSCRIPCION_12_MESES,
      nombre: "Catálogo Truper 2026 con 12 meses de actualizaciones",
      meses: 12,
      gratis: false,
      descripcion:
        "Recibe el Catálogo Truper 2026 en formato Excel* con todos los productos VIGENTES y con hasta 12 meses de actualizaciones de precios de los productos de alta volatilidad de acuerdo a la PROMOTRUPER  ​(precios en pesos MX).",
    },
    [susInventarioAccionFerretera.SUSCRIPCION_6_MESES]: {
      codigo: susInventarioAccionFerretera.SUSCRIPCION_6_MESES,
      nombre: "Catálogo Truper 2026 con 6 meses de actualizaciones",
      meses: 6,
      gratis: false,
      descripcion:
        "Recibe el Catálogo Truper 2026 en formato Excel* con todos los productos VIGENTES y con hasta 6 meses de actualizaciones de precios de los productos de alta volatilidad de acuerdo a la PROMOTRUPER  ​(precios en pesos MX).",
    },
    [susInventarioAccionFerretera.SUSCRIPCION_3_MESES]: {
      codigo: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
      nombre: "Catálogo Truper 2026 con 3 meses de actualizaciones",
      meses: 3,
      gratis: false,
      descripcion:
        "Recibe el Catálogo Truper 2026 en formato Excel* con todos los productos VIGENTES y con hasta 3 meses de actualizaciones de precios de los productos de alta volatilidad de acuerdo a la PROMOTRUPER  ​(precios en pesos MX).",
    },
    [susInventarioAccionFerretera.SUSCRIPCION_1_MES]: {
      codigo: susInventarioAccionFerretera.SUSCRIPCION_1_MES,
      nombre: "Suscripción de 1 mes GRATIS",
      meses: 1,
      gratis: true,
      //TODO cambiar la descripcion del la suscripcion de 1 mes
      descripcion:
        "Un mes gratuito del cotizador y buscador de productos truper con precios actualizados.",
    },
}

export const validarSuscripcionVigenteAF = (susObj) => {
  if(!susObj) return false

  const sus = Array.isArray(susObj) ? susObj : Object.values(susObj)

  // return suscripcionVigente(getSuscripcionVigenteAF(sus))
  const susVigente = getSuscripcionVigenteAF(sus)
  console.log("🚀 ~ validarSuscripcionVigenteAF ~ susVigente:", susVigente)
  
  return !!susVigente?.codigo
}

export const validarSuscripcionAF = codigo => validarSuscripcionBase(suscripcionesDisponiblesAccionFerretera, codigo)
export const validarSuscripcionPagoAF = codigo => validarSuscripcionPagoBase(suscripcionesDisponiblesAccionFerretera, codigo) 
export const validarSuscripcionGratuitaAF = codigo => validarSuscripcionGratuitaBase(suscripcionesDisponiblesAccionFerretera, codigo)

export const getSuscripcionVigenteAF = (susLst = []) => getSuscripcionVigenteBase(suscripcionesDisponiblesAccionFerretera, susLst)

export const getSuscripcionVencimientoMesAF = (susLst = [], ajusteMes = 0) => getSuscripcionVencimientoMesBase(suscripcionesDisponiblesAccionFerretera, susLst, ajusteMes)

export const tieneSuscripcionVencidaAF = (susLst) => tieneSuscripcionVencidaBase(suscripcionesDisponiblesAccionFerretera, susLst)


export const forms_checkout = {
  "2122541000001357009": {
    id: "2122541000001357009",
    nombre: "Catálogo Truper 2026 Excel",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: false,
  },
  "2122541000000832003": {
    id: "2122541000000832003",
    nombre: "Catálogo Truper 2024 Excel",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: false,
  },
  "2122541000000375104": {
    id: "2122541000000375104",
    nombre: "Renovación por 3 meses - Actualizaciones del Catalogo Truper 2024",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: true,
  },
  "2122541000000375133": {
    id: "2122541000000375133",
    nombre: "Renovación por 6 meses - Actualizaciones del Catalogo Truper 2024",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_6_MESES,
    esRenovacion: true,
  },
  "2122541000001232048": {
    id: "2122541000001232048",
    nombre: "Suscripción por 6 meses - Actualizaciones de precios",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_6_MESES,
    esRenovacion: false,
  },
  "2122541000000264009": {
    id: "2122541000000264009",
    nombre: "Suscripción al Catálogo Truper Online con precios actualizados",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: false,
  },
  "2122541000000846003": {
    id: "2122541000000846003",
    nombre: "COMBO DUO (Catálogo Truper 2024 Excel más Banco de Imágenes)",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: false,
  },
  "2122541000001425003": {
    id: "2122541000001425003",
    nombre: "COMBO DUO (Catálogo Truper 2026 Excel más Banco de Imágenes)",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: false,
  },
  "2122541000000665003": {
    id: "2122541000000665003",
    nombre:
      "Suscripción al POS Truper Online Ilimitado y Precios Actualizados - 3 meses",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: false,
  },
  "2122541000000465011": {
    id: "2122541000000465011",
    nombre: "Suscripción al Cotizador Digital con Precios Actualizados",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: false,
  },
  "2122541000001232003": {
    id: "2122541000001232003",
    nombre: "Suscripción por 3 meses - Actualizaciones de precios",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_3_MESES,
    esRenovacion: false,
  },
  "2122541000001232065": {
    id: "2122541000001232065",
    nombre: "Suscripción por 1 año - Actualizaciones de precios",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_12_MESES,
    esRenovacion: false,
  },
  "2122541000001718005": {
    id: "2122541000001718005",
    nombre: "Renovación por 1 año - Actualizaciones de Precios del Catalogo Truper",
    suscripcion: susInventarioAccionFerretera.SUSCRIPCION_12_MESES,
    esRenovacion: true,
  },
}

export const membresiasInventarioAF = {
  COMPRADOR_MAYORISTA: "COMPRADOR_MAYORISTA",
}

export const membresiasDisponiblesAF = {
  [membresiasInventarioAF.COMPRADOR_MAYORISTA]: {
    codigo: membresiasInventarioAF.COMPRADOR_MAYORISTA,
    nombre: "Comprador Mayorista",
    descripcion: "",
  },
}

export const validarMembresia_COMPRADOR_MAYORISTA = codigo =>
  codigo === membresiasInventarioAF.COMPRADOR_MAYORISTA

export const getMembresiaVigente_COMPRADOR_MAYORISTA = (memsLst = []) =>
  memsLst.filter(
    s =>
      validarMembresia_COMPRADOR_MAYORISTA(s.codigo) && esMembresiaVigente(s)
      // s?.fin_aniomes &&
      // s.fin_aniomes >= getAniomesActual()
  )?.[0]

      // validacion={({ infoUsuarios: { membresias: memsObj = {} } = {} }) =>
      //   getMembresiaVigente_COMPRADOR_MAYORISTA(Object.values(memsObj))
      // }

export const validarMembVigenteCompMayorista = (memsObj) => {
  if (!memsObj) return false

  const sus = Array.isArray(memsObj) ? memsObj : Object.values(memsObj)

  const membVigente = getMembresiaVigente_COMPRADOR_MAYORISTA(sus)
  console.log("🚀 ~ validarMembVigenteCompMayorista ~ membVigente:", membVigente)

  return !!membVigente?.codigo
}
